import jsonLogic from 'json-logic-js';
import config from './uiConfig';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);
dayjs.extend(localizedFormat);

export const formatDateInterval = (startDateU, endDateU) => {
  const startDate = dayjs(startDateU);
  const endDate = dayjs(endDateU);
  if (!endDateU || endDateU === startDateU)
    return startDate.format("LL");
  if (startDate.month() === endDate.month())
    return `${startDate.format("MMMM D")} – ${endDate.format("D, YYYY")}`;
  return dayjs(startDate).format("MMMM D") + " – " + dayjs(endDate).format("LL");
}

const setValidity = (id, text) => {
  const el = document.getElementById(id);
  el.setCustomValidity(text);
  el.reportValidity();
}

export const validateCustomFields = (formMetaData, state, setErrors) => {
  if (!formMetaData)
    return true;
  for (let field of formMetaData.fields) {
    if (field.condition && !jsonLogic.apply(field.condition, state))
      continue;
    if (field.type === "text" && field.regex && state[field.id]) {
      const re = new RegExp(field.regex);
      if (!re.test(state[field.id])) {
        console.warn("validation error", field.id, field.regex, state[field.id]);
        setValidity(field.id, "Wrong format");
        return false;
      }
    }
    if (field.type === "phone" && field.mandatory) {
      if (state[field.id].length < 8) {
        console.warn("validation error", field.id);
        setValidity(field.id, field.label + " required");
        return false;
      }
    }
    if (field.type === "radio" && field.mandatory) {
      if (!state[field.id]) {
        console.warn("validation error", field.id);
        setValidity(field.id + "0", "Please choose an option");
        return false;
      }
    }
    if (field.type === "checkbox" && field.mandatory) {
      if (!state[field.id]) {
        console.warn("validation error", field.id);
        setValidity(field.id, "You must check to proceed");
        return false;
      }
    }
    if (field.type === "checkbox" && field.mandatory) {
      if (!state[field.id]) {
        console.warn("validation error", field.id);
        setValidity(field.id, "You must check to proceed");
        return false;
      }
    }
    if (field.type === "select" && field.mandatory) {
      if (!state[field.id]) {
        console.warn("validation error", field.id);
        setErrors({ [field.id]: "Please choose an option" })
        // setValidity(field.id, "Please choose an option");
        return false;
      }
    }
  }
  return true;
}

export const getPricingData = (reasons, state) => {
  let pricing = {};
  for (let reason of reasons) {
    pricing[reason] = state[reason];
  }
  return JSON.stringify(pricing);
}

export const getUpcomingEvents = events => events.filter(x => dayjs.duration(dayjs() - dayjs(x.endDate || x.startDate)).asDays() < (config.eventsDebugMode ? 9999 : 2))